import type { PortableTextBlock, PortableTextBlockComponent, PortableTextComponentProps, PortableTextComponents, PortableTextTypeComponentProps } from "@portabletext/react";
import { getImageDimensions, type SanityImageSource } from "@sanity/asset-utils"
import type { ImageUrlBuilder } from "@sanity/image-url/lib/types/builder";

export const getPortableTextComponents: (builder: ImageUrlBuilder) => PortableTextComponents = (builder) => ({
	block: {
		"h1": (props) => {
			return <h1 className="text-5xl font-semibold">{props.children}</h1>;
		},
		"h2": (props) => {
			return <h2 className="text-3xl font-semibold mt-4 mb-2">{props.children}</h2>;
		},
		"normal": (props) => {
			return <p className="text-base mb-4">{props.children}</p>;
		},
		//  'blockquote',  'h3',  'h4',  'h5',  'h6'
	},
	types: {
		image: ({ value, isInline }) => {
			const { width, height } = getImageDimensions(value)
			return (
				<img
					src={builder
						.image(value)
						// .width(isInline ? 100 : 800)
						.fit("max")
						.auto("format")
						.url()}
					alt={value.alt || " "}
					loading="lazy"
					className="my-3"
					style={{
						// Display alongside text if image appears inside a block text span
						display: isInline ? "inline-block" : "block",

						// Avoid jumping around with aspect-ratio CSS property
						aspectRatio: width / height,
					}}
				/>
			)
		},
		callToAction: ({ value, isInline }) =>
			isInline ? (
				<a href={value.url}>{value.text}</a>
			) : (
				<div>{value.text}</div>
			),
	},

	marks: {
		image: ({ value }) => {
			const { width, height } = getImageDimensions(value)
			return (
				<img src={builder
					.image(value)
					.width(100)
					.fit("max")
					.auto("format")
					.url()}
					alt={value.alt || " "}
					loading="lazy"
					style={{
						// Display alongside text if image appears inside a block text span
						display: "inline-block",

						// Avoid jumping around with aspect-ratio CSS property
						aspectRatio: width / height,
					}}
				/>
			)
		},
		link: ({ children, value }) => {
			const url: string | undefined = value.href ?? value.url;
			const rel = !url?.startsWith("/") ? "noreferrer noopener" : undefined
			return (
				<a href={url} rel={rel} target={value.blank ? " _blank" : ""}>
					{children}
				</a>
			)
		},
		strong: ({ children, value }) => {
			return <span className="font-bold text-lg">{children}</span>
		}
	},
})